import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TicketState {
  selectedRow: any[];
  selectedDropdownValue: any | null;
  isSelectionRemove: boolean;
}

const initialState: TicketState = {
  selectedRow: [],
  selectedDropdownValue: {},
  isSelectionRemove:false,
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    setSelectedRow: (state, action: PayloadAction<any[]>) => {
      state.selectedRow = action.payload;
    },
    setSelectedDropdownValue: (state, action: PayloadAction<any>) => {
      state.selectedDropdownValue = action.payload;
    },
    setIsSelectionRemove: (state, action: PayloadAction<boolean>) => {
      state.isSelectionRemove = action.payload;
    }
  },
});

export const {
  setSelectedRow,
  setSelectedDropdownValue,
  setIsSelectionRemove
} = ticketSlice.actions;
export default ticketSlice.reducer;
